// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__oxnTF","title":"InfoRow_title__196Gg"};